
import Vue from 'vue'

import Banner from '@/components/banners/WarningBanner.vue'
import EditBillingInfo from '@/components/account/EditBillingInfo.vue'
import { RButton } from '@/components'
import { mapActions, mapGetters } from 'vuex'
import { getAppRootURL } from '@/config'

export default Vue.extend({
  name: 'MissingPayment',
  head: {
    link: [{ rel: 'canonical', href: `${getAppRootURL()}/missing-payment/`, id: 'canonical' }],
  },
  components: {
    EditBillingInfo,
    Banner,
    RButton,
  },
  methods: {
    ...mapActions({
      logOut: 'user/logOut',
    }),
  },
  computed: {
    ...mapGetters({
      loggedIn: 'user/loggedIn',
    }),
  },
})
